import request from "../../utils/request";

/**
 * 拣货单结算列表
 * @param params
 * @returns {*}
 */
export function ordPickingSettleList(params) {
  return request({
    url: "/api/order/ordPickingSettle",
    method: "get",
    params: params,
  });
}

/**
 * 拣货单结算同步
 * @returns {*}
 * @param selectIds
 */
export function ordPickingSettleSync(selectIds) {
  const data = { settleIds: selectIds };
  return request({
    url: "/api/order/ordPickingSettle/sync",
    method: "post",
    data: data
  });
}

/**
 * 拣货单结算详情
 * @returns {*}
 * @param sid
 */
export function ordPickingSettleDetail(sid) {
  return request({
    url: "/api/order/ordPickingSettle/" + sid,
    method: "get"
  });
}

/**
 * 拣货单结算详情列表
 * @returns {*}
 * @param params
 */
export function ordPickingSettleDetailList(params) {
  return request({
    url: "/api/order/ordPickingSettleDetail",
    method: "get",
    params: params,
  });
}

/**
 * 拣货单结算财务关系
 * @returns {*}
 * @param params
 */
export function ordPickingSettleFinancial() {
  return request({
    url: "/api/order/ordPickingSettle/financial",
    method: "get"
  });
}
